<template>
  <div class="lamp__preview" @click="handleClick(lamp.productId)" :id="'lamp-' + lamp.productId">
    <span v-if="lamp.productId" class="lamp__preview-id">
      {{
      lamp.productId
      }}
    </span>
    -
    <span v-if="lamp.name" class="lamp__preview-name">{{ lamp.name }}</span>
    <span
      v-if="lamp.colour"
      class="lamp__preview-colour"
    >, {{ $t("lamp.colour") }}: {{ lamp.colour }}</span>
    <span
      v-if="lamp.colourtemperature"
      class="lamp__preview-colourtemperature"
    >, {{ $t("lamp.colourtemperature") }}: {{ lamp.colourtemperature }}</span>
    <span v-if="lamp.w" class="lamp__preview-w">, {{ $t("lamp.w") }}: {{ lamp.w }}</span>
  </div>
</template>

<script>
export default {
  props: {
    lamp: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleClick(lamp) {
      this.$emit("set-suggested-article", lamp);
      //or shall I put this directly into the store?
    }
  }
};
</script>

<style lang="scss" scoped>
.lamp__preview {
  text-align: left;
  transition: all 0.4s;
  padding: 0.3% 1%;
  padding: 1%;
  transition: all 0.4s;
  &:hover {
    transition: all 0.4s;
    cursor: pointer;
    background-color: #000;
    color: #fff;
  }
  span {
    // white-space: nowrap;
  }
}
</style>
